import { render, staticRenderFns } from "./UploadOnBoardDocuments.vue?vue&type=template&id=de76853c&scoped=true"
import script from "./UploadOnBoardDocuments.vue?vue&type=script&lang=js"
export * from "./UploadOnBoardDocuments.vue?vue&type=script&lang=js"
import style0 from "./UploadOnBoardDocuments.vue?vue&type=style&index=0&id=de76853c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de76853c",
  null
  
)

export default component.exports